import styled from "styled-components/macro";
import { forMinWidth } from "../../theme/breakpoints";

const PageHeader = styled.header<{ withDarkBackground?: boolean, overrideHeaderColor?: string, isInternal: boolean }>`
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    background-color: ${props => props.withDarkBackground ? "var(--color-surface-dark2)" : (props.overrideHeaderColor ?? "var(--color-secondary)")};
    color: var(--color-on-secondary);
    min-height: 10rem;
    transition: background-color .5s ease;

    font-weight: 600;
    font-size: 3.2rem;
    /* For high contrast mode */
    border-top: ${props => props.withDarkBackground ? "solid 1px var(--color-surface-dark2)" : "solid 1px var(--color-secondary)"};
    border-bottom: ${props => props.withDarkBackground ? "solid 1px var(--color-surface-dark2)" : "solid 1px var(--color-secondary)"};
    padding: 2rem 1rem;
    ${forMinWidth.md`
        padding: 2rem 15%;
    `}
`;

export default PageHeader;
